import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, SectionBadge } from "./Shared";
import { IMAGES } from "../data";

export default function Story() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [-50, 50]);

  return (
    <section id="story" ref={ref} className="overflow-hidden py-24 md:py-32">
      <div className="mx-auto grid max-w-[1440px] grid-cols-1 items-center gap-16 px-6 md:px-10 lg:grid-cols-12">
        <div className="relative lg:col-span-5">
          <Reveal>
            <div className="overflow-hidden rounded-t-[999px] rounded-b-[32px] border border-leaf/15">
              <motion.img
                src={IMAGES.botanical}
                alt="Fresh oranges and botanical leaves"
                data-testid="story-image"
                style={{ y, scale: 1.15 }}
                className="aspect-[4/5] w-full object-cover"
              />
            </div>
          </Reveal>
          <p className="absolute -right-2 bottom-10 -rotate-6 font-cursive text-3xl text-melon md:text-4xl">
            juiced with love
          </p>
        </div>

        <div className="lg:col-span-7 lg:pl-10">
          <Reveal>
            <SectionBadge>03 — Our Story</SectionBadge>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-8 font-serif text-5xl font-medium leading-[0.95] tracking-tighter text-ink md:text-7xl">
              From our hands <span className="italic text-leaf">to your bottle</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 max-w-xl text-base font-light leading-relaxed text-leaf/85 md:text-lg">
              Main Squeeze started with one simple belief — that what you drink
              should love you back. Every morning we press small batches of
              cold-pressed juice from fresh fruit, vegetables and roots, with
              nothing added and nothing taken away.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <p className="mt-5 max-w-xl text-base font-light leading-relaxed text-leaf/85 md:text-lg">
              Whether it's a quick wellness shot before work or a refreshing
              juice for your daily routine, every bottle is prepared in small
              batches using fresh ingredients and made with the care you can
              taste. That's the Squeeze difference.
            </p>
          </Reveal>
          <Reveal delay={0.4}>
            <div className="mt-12 grid max-w-xl grid-cols-3 gap-6 border-t border-leaf/15 pt-8">
              {[
                ["Daily", "fresh pressing"],
                ["Small", "batch only"],
                ["Fresh", "quality produce"],
              ].map(([big, small]) => (
                <div key={small}>
                  <p className="font-serif text-2xl font-medium italic text-leaf md:text-3xl">{big}</p>
                  <p className="mt-1 text-[11px] uppercase tracking-[0.2em] text-leaf/60">{small}</p>
                </div>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.5}>
            <p className="mt-10 font-cursive text-3xl text-leaf">— The Main Squeeze family</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
